<template>
	<div class="st-main-content">
		<div class="query-setting-box">
            <div class="order-query-form-box">
                <label for="start-date">角色类型：</label>
                <span class="order-query-form-input">
                    <el-select v-model="orderForm.userType" placeholder="请选择" class="stSetSelect">
                        <el-option
                        v-for="item in userTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </span>
            </div>
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone"></span>
				</div>
			</div>
			<div class="order-query-form-box">
				<label for="start-date">用券剩余>0</label>
				<el-switch
                v-model="orderForm.unused"
                active-color="#13ce66"
                inactive-color="#ff4949">
                </el-switch>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>

        <div class="data-table-box">
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showPage="true"
				:loading="loading"

				:showSummary="true"
                :count-data="dataTotal"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
			</common-table>
        </div>
		
	</div>
</template>
<script>
export default {
	name: 'DriverAccount',
	props: [],
	components: {},
	data(){
		return{
            tableColumns:[
                {
                    key: '',
                    title: '操作',
                    align:'center',
                    operate:true,
                    setBtns:(row,index)=>{
                        return [
                            {
                                label:'查看明细',
                                handler: (row,index) => this.toDetail(row)
                            }
                        ]
                    }
                },{
                    key: 'userTypeDesc',
                    align:'center',
                    title: '角色类型',
                },{
                    key: 'name',
                    align:'center',
                    title: '名称',
                },{
                    key: 'phone',
                    align:'center',
                    title: '手机号',
                },{
                    key: 'useCount',
                    align:'center',
                    title: '已使用张数',
                },{
                    key: 'unUseCount',
                    align:'center',
                    title: '剩余张数',
                }
            ],
            loading: false,
            pageConfig: {
                total: 0,
                pageSize: 50,
                currentPage: 1,
            },
            bottomHandleArr: [
                {
                    label: '导出',
                    handler: () => this.exportTable()
                }
            ],
			dataList:[], //订单列表
			dataTotal: {},
			orderForm:{
                unused: false,
				phone: null, //	司机手机	string	
			},
			listPage:{
				currentSize:50,
				current: 1, //分页起始位置
				total: 0, // 总数量
				sizes: [{value:50,label:'每页50条'},{value:100,label:'每页100条'},{value:200,label:'每页200条'},{value:300,label:'每页300条'}], //分页大小
				page:1,
				pages:0,//总页数
			},
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			toggleStDialog:false,// 弹窗
			userTypeList:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '货主'
				}, {
					value: 2,
					label: '司机'
				}],
		}
	},
	methods: {
        sizeChange(size) {
            this.pageConfig.currentPage = 1
            this.pageConfig.pageSize = size
            this.searchList()
        },

        currentChange(currentPage) {
            this.pageConfig.currentPage = currentPage
            this.searchList()
        },
		getSummaries(param) {
				// 处理合计不显示问题
				this.$nextTick(() => {
					this.$refs.table.doLayout();
				});
				let vm = this;
				let sums = [];
				var selectedColm = param.columns;
				let newArray = []
				selectedColm.forEach(a => {
					if (vm.dataTotal[a.property]) {
					newArray.push(vm.dataTotal[a.property])
					} else {
					newArray.push('')
					}
					
				});
				sums = newArray;
				sums[0] = "合计";
				return sums;
			},
		cellClass(row){     
			if (row.columnIndex === 0) {           
				return 'disabledCheck'     
			} 
		},
		selectionChange(val){
			this.selectedList=val;
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		getData(data){
            this.loading=true
            this.$server.financial.queryAllCount({
                ...data,
                unused:data.unused?1:0
            }, (res) => {
                this.dataTotal = res.data
                this.dataTotal.userTypeDesc=''
			})
			this.$server.financial.queryAll({
                ...data,
                unused:data.unused?1:0
            },(res)=>{
                this.loading=false
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		// 导出
		exportTable(){
			if (this.dataList.length < 1) {
                this.$toast.stMessage('暂无订单', true)
                return;
			}
			let pages = {};
			pages.size = this.listPage.currentSize;
			pages.current = this.listPage.current;
			const sendData = {
                ...this.orderForm,
                exportColumnFiledNames: this.tableColumns.map((item) => {
					return  item.key
				}).filter(item => {
					return item && item.trim()
				})
            }
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/coupon/queryAllExcle', {
                ...sendData,
                unused :sendData.unused?1:0
            }, (res) => {
			    console.log('导出成功')
			})
			
        },
        toDetail(row){
            console.log(row.uid)
            this.$store.dispatch('common/addTab', {
				title: '优惠券明细',
				path: 'report/CouponDetail',
				name: 'CouponDetail',
				params:{
                    uid:row.uid
                }
			})
        }
	},
	mounted() {
		
	}
}

</script>
<style scoped>

.driver-account {
  width: 100%;
  height: auto;
}
.data-table-box {
	/* display: flex;
	justify-content: center;
	align-items: center; */
    height: auto;
    background: #FFF;
    padding: 8px;
	box-sizing: border-box;
	text-align: center;
}	
.data-table-warp{
	/* display: inline-block; */
	width: auto;
	margin: 0 auto;
}
.data-table{
	margin-bottom: 8px;
	/* border: 1px solid #ccc; */
}
.query-setting-box-left{
    flex-grow: 0;
}
</style>
